import React from "react";

const Footer = () => {
  return (
    <div className=" bg-dark text-light p-4">
      <h6 className="text-center text-white">
        All rights reserved &copy; VinayKumar
      </h6>
    </div>
  );
};

export default Footer;